import React from 'react';
import { toast, Flip } from 'react-toastify';
import { Loading } from "seed/helpers";
import { getNodeContent } from "components/util/node_util";

const getFlowName = (flow, category) => {
  const templateSettings = flow?.templateSettings ?? {};
  const templateSettingsName = templateSettings?.name ?? {};

  if (typeof templateSettingsName === "string")
    return templateSettingsName;

  const templateSettingsNameKeys = Object.keys(templateSettingsName)

  if (category && templateSettingsNameKeys.includes(category?.name)) {
    return templateSettingsName[category.name];
  }

  if (templateSettingsNameKeys.includes("default")) {
    const defaultName = templateSettingsName["default"];
    return defaultName;
  }

  return flow?.name ?? "";

}

const showExecutionToast = ({
  exception,
  status,
  executionId,
  nodes,
  lastNode,
  message,
  awaitingAlert,
  executionSessionId,
  setIsExecutionDetailsShown = () => { },
  setCurrentExecutionId = () => { },
}) => {

  if (executionSessionId && executionSessionId != sessionStorage.getItem("execution_session_id")) return;
  if (status == "AWAITING" && !awaitingAlert) return toast.dismiss(executionId);

  const flowNode = nodes?.find(node => node.data.remoteId == lastNode?.id);

  const displayOptions = lastNode?.action?.ui_settings?.node ?? [];
  const formSettings = lastNode?.action?.ui_settings?.form;
  const nodeInput = lastNode?.input_values;

  const title = getNodeContent(displayOptions, nodeInput, "title", formSettings);
  const nodeIdx = flowNode?.data?.idx;

  let attrs = {
    position: "top-right",
    autoClose: status == "RUNNING" ? false : 2250,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    toastId: executionId,
    transition: Flip,
    onClick: () => {
      setIsExecutionDetailsShown(true);
      setCurrentExecutionId(executionId);
    }
  }

  let text = ""
  let subtitle = ""
  let button = ""

  if (status == "RUNNING") {
    text = 'Proceso en ejecución ...'
    attrs.icon = ({ theme, type }) => <Loading size={18} />
    attrs.type = "info"
  }

  if (status == "OK") {
    text = 'Proceso completado'
    attrs.icon = null
    attrs.type = "success"
    attrs.autoClose = 500000
    button = <button className="btn btn-sm btn-primary py-1 mt-1" onClick={() => setIsExecutionDetailsShown(true)}>
      Ver resultados
    </button>
  }

  if (status == "FAILED") {
    attrs.icon = null
    attrs.type = "error"
    text = 'Ha ocurrido un error'
    subtitle = <div className='text-danger'>{LimitExceptions[exception?.type] || exception?.message || ""}</div>
  }

  if (status == "AWAITING" && awaitingAlert) {
    // return toast.dismiss(executionId);
    text = 'Proceso en espera'
    subtitle = `#${nodeIdx}\n${title}`
    attrs.icon = null
    attrs.type = "info"
    attrs.autoClose = 500000
  }

  let result = (
    <div className="ml-1" style={{ cursor: "pointer !important" }}>
      <div>{text}</div>
      {subtitle ? <div><span style={{ fontSize: "0.9em" }}>{subtitle}</span></div> : null}
      {button}
    </div>
  )

  if (!toast.isActive(executionId)) toast(result, attrs);
  else toast.update(executionId, { ...attrs, render: result });

}

const LimitExceptions = {
  "flow_limit": "Has llegado al tope de tu licencia. Puedes contactar a support@workix.mx para más información",
  "no_license": "No tienes una licencia válida. Puedes contactar a support@workix.mx para más información",
  "execution_steps_limit": "Has llegado al tope de pasos de ejecución de tu licencia. Puedes contactar a support@workix.mx para más información",
  "execution_time_limit": "Has llegado al tope de tiempo de ejecución de tu licencia. Puedes contactar a support@workix.mx para más información"
}

export { getFlowName, showExecutionToast, LimitExceptions };